import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
import {useSelector} from "react-redux";
import {apiUrlSelector} from "../redux/selectors";

export const useCreateStopGroup = ({ onError, onSuccess}) => {
    
    const apiUrl = useSelector(apiUrlSelector);
    const queryClient = useQueryClient();

    return useMutation(values => {
        
            if ( parseInt(values.id) > 0 ) {
                return axios.patch(`${apiUrl}stop-groups/${values.id}`, values).then(res => res.data);
            } else {
                return axios.post(`${apiUrl}stop-groups`, values).then(res => res.data)
            }
        },
        {
            onSuccess: () => {
                onSuccess();
                queryClient.invalidateQueries(["stop-groups", apiUrl]);
            }, onError: onError
        }
    );
};

export default useCreateStopGroup;